import { LINK_WEBSITE } from 'shared/constants/links.ts'
import { getCDNAssetURL } from 'shared/lib'
import fullLogoImg from 'shared/assets/images/fullLogo.png'
import styles from './styles.module.scss'

export const AuthHeader = () => (
  <div className={styles.logoWrap}>
    <a href={LINK_WEBSITE} target='_blank' rel='noreferrer'>
      <img className={styles.logo} alt='logo' src={getCDNAssetURL(fullLogoImg)} />
    </a>
  </div>
)
